import { ActionHandler } from "@pageDefinitions/actions";
import { onStartSurvey } from "@pageDefinitions/actions/survey/onStartSurvey";
import getStore from "@utils/redux/store";
import { resetCurrentAnswers } from "@utils/redux/slices/currentAnswers";
import { trackCurrentTierEvent } from "@utils/counterOffer";
import { getPageSetSurvey } from "@pageDefinitions/actions/survey/util";

export const onStartMedDowngradeSurvey: ActionHandler = (actionConfig) => {
  onStartSurvey(actionConfig);
  const store = getStore();
  const survey = getPageSetSurvey(actionConfig.pageSet, actionConfig.page);
  const { surveyNameSpace } = survey;

  store.dispatch(
    resetCurrentAnswers({
      namespace: surveyNameSpace,
      answers: {},
    })
  );

  trackCurrentTierEvent();
};
